module.exports = __webpack_public_path__ + "static/media/6.9fc05eac.png";